import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import InputText from "../../components/forms/elements/InputText";
import GrupoModuloService from "../../services/GrupoModuloService";
import CrudForm from "../../components/forms/custom/CrudForm";

class FormGrupoModulo extends CrudForm {

    constructor(props) {
        super(props);

        this.state.model = {
            idGrupoModulo: "",
            nome: ""
        };

        this.state.crud = {
            service: GrupoModuloService,
            labels: {
                title: 'Grupo Módulo',
            },
            urlList: '/LstGrupoModulo',
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderFields() {
        return (
            <div className="row mb-3 g-3">
                <InputText label="Código" md={3} value={this.state.model.idGrupoModulo} name="idGrupoModulo" readOnly opcionalLabel={false}/>
                <InputText label="Nome da Grupo Módulo" autoFocus={true} required md={9} value={this.state.model.nome} name="nome" onChange={this.handleChange} maxLength={100} />
            </div>
        );
    }

    render() {
        return super.render();
    }
}

function With(props) {
    let navigate = useNavigate();
    let params = useParams();
    return <FormGrupoModulo {...props} navigate={navigate} params={params} />
}

export default With